import { useContext } from "react";

import { FlooringTypesContext } from "../contexts/FlooringTypesContext";

export const useFlooringTypes = () => {
  return useContext(FlooringTypesContext);
};